import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http } from "@/lib/api";
import { BookOpen, ArrowRight } from "lucide-react";
import Header from "@/components/Header";

export default function BlogIndex() {
  const [posts, setPosts] = useState([]);
  const [tab, setTab] = useState("All");

  useEffect(() => {
    http.get("/blog/posts").then(({ data }) => setPosts(data.posts || [])).catch(() => {});
  }, []);

  const categories = ["All", "Blog", "FAQ"];
  const filtered = tab === "All" ? posts : posts.filter((p) => p.category === tab);

  return (
    <div data-testid="blog-index" className="min-h-screen bg-app text-app">
      <Header />
      <section className="pt-32 pb-16 max-w-5xl mx-auto px-6">
        <div className="mb-10">
          <span className="text-xs uppercase tracking-[0.3em] text-[#C9A961] font-semibold">The notebook</span>
          <h1 className="font-serif text-4xl sm:text-5xl mt-3">Immigration guides & FAQs</h1>
          <p className="text-app-muted mt-2 text-sm">Fresh insights, policy breakdowns and answers from the NextShore team.</p>
        </div>

        <div className="flex gap-2 mb-8">
          {categories.map((c) => (
            <button
              key={c}
              data-testid={`blog-tab-${c.toLowerCase()}`}
              onClick={() => setTab(c)}
              className={`rounded-full px-4 py-1.5 text-xs uppercase tracking-widest font-semibold border transition-colors ${
                tab === c ? "bg-[#0B1E3F] text-white border-[#0B1E3F]" : "border-[var(--card-border)] text-app-muted hover:border-[#C9A961]"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        {filtered.length === 0 && (
          <div data-testid="blog-empty" className="rounded-2xl border border-dashed border-[var(--card-border)] p-10 text-center text-app-muted">
            <BookOpen className="w-7 h-7 mx-auto mb-3 opacity-60" />
            Nothing published yet. Check back soon.
          </div>
        )}

        <div className="grid sm:grid-cols-2 gap-6">
          {filtered.map((p) => (
            <Link
              key={p.id}
              to={`/blog/${p.slug}`}
              data-testid={`blog-card-${p.slug}`}
              className="group rounded-2xl border border-[var(--card-border)] bg-app-alt overflow-hidden hover:border-[#C9A961] transition-colors"
            >
              {p.cover_url && (
                <div className="aspect-[16/9] bg-slate-900/40 overflow-hidden">
                  <img src={p.cover_url.startsWith("http") ? p.cover_url : `${process.env.REACT_APP_BACKEND_URL}${p.cover_url}`} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
              )}
              <div className="p-6">
                <div className="text-[11px] uppercase tracking-widest text-[#C9A961] font-semibold mb-2">{p.category}</div>
                <h3 className="font-serif text-xl group-hover:text-[#C9A961] transition-colors">{p.title}</h3>
                <p className="text-sm text-app-muted mt-2 line-clamp-3">{p.excerpt || p.body.slice(0, 160)}</p>
                <div className="mt-4 text-xs text-app-muted flex items-center gap-1.5">
                  Read article <ArrowRight className="w-3 h-3" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
